export const formatDate = (
  dateString: string,
  withTime = true,
  separator = ".",
  dateTimeSeparator = " o ",
) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  if (withTime) {
    const hour = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}.${month}.${year}${dateTimeSeparator}${hour}:${minutes}`;
  }

  return `${day}${separator}${month}${separator}${year}`;
};
